import { format } from 'date-fns';

/**
 * Returns date in M/d/yyyy format (eg: 9/7/2021)
 */
var formatDate = function formatDate(date) {
  return format(date, 'M/d/yyyy');
};
export default formatDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/formatDate.js
// module id = 2644
// module chunks = 11